import { JSX } from 'react'

import { IconProps } from '../../icon'

const Noocs: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.3077 21.1282C35.0277 21.1282 33.9118 21.7846 33.239 22.7692H29.8092C28.9231 19.9303 26.2974 17.8462 23.1795 17.8462C22.2769 17.8462 21.4072 18.0267 20.6195 18.3549L18.8964 15.7785C19.7662 14.9579 20.3077 13.8092 20.3077 12.5128C20.3077 10.0185 18.2892 8 15.7949 8C13.3005 8 11.2821 10.0185 11.2821 12.5128C11.2821 15.0072 13.3005 17.0256 15.7949 17.0256C16.1067 17.0256 16.4185 16.9928 16.7138 16.9272L18.5354 19.6513C17.1241 20.9313 16.2051 22.7528 16.2051 24.8205C16.2051 26.2974 16.681 27.6595 17.4687 28.7918L16.1231 30.1374C15.3026 29.6287 14.3672 29.3333 13.3333 29.3333C10.3959 29.3333 8 31.7292 8 34.6667C8 37.6041 10.3959 40 13.3333 40C16.2708 40 18.6667 37.6041 18.6667 34.6667C18.6667 33.6492 18.3549 32.6974 17.8626 31.8769L19.2082 30.5313C20.3405 31.319 21.7026 31.7949 23.1795 31.7949C26.8882 31.7949 29.8913 28.8903 30.1046 25.2308H32.6482C32.8615 27.0687 34.4041 28.5128 36.2913 28.5128C38.3262 28.5128 39.9836 26.8554 39.9836 24.8205C39.9836 22.7856 38.3262 21.1282 36.2913 21.1282H36.3077ZM13.7436 12.5128C13.7436 11.3805 14.6626 10.4615 15.7949 10.4615C16.9272 10.4615 17.8462 11.3805 17.8462 12.5128C17.8462 13.6451 16.9272 14.5641 15.7949 14.5641C14.6626 14.5641 13.7436 13.6451 13.7436 12.5128ZM13.3333 37.5385C11.7579 37.5385 10.4615 36.2421 10.4615 34.6667C10.4615 33.0913 11.7579 31.7949 13.3333 31.7949C14.9087 31.7949 16.2051 33.0913 16.2051 34.6667C16.2051 36.2421 14.9087 37.5385 13.3333 37.5385ZM23.1795 29.3333C21.9323 29.3333 20.8164 28.8246 19.9959 28.0041C19.1754 27.1836 18.6667 26.0513 18.6667 24.8205C18.6667 22.3262 20.6851 20.3077 23.1795 20.3077C25.6738 20.3077 27.6923 22.3262 27.6923 24.8205C27.6923 27.3149 25.6738 29.3333 23.1795 29.3333ZM36.3077 26.0513C35.6349 26.0513 35.0769 25.4933 35.0769 24.8205C35.0769 24.1477 35.6349 23.5897 36.3077 23.5897C36.9805 23.5897 37.5385 24.1477 37.5385 24.8205C37.5385 25.4933 36.9805 26.0513 36.3077 26.0513Z'
      fill='black'
    />
  </svg>
)

export default Noocs
